import { lazy, Suspense } from "react";
import CircularLoader from "../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../components/resetPassword/main"));

const ResetPassword = () => {
    return (
        <Suspense fallback={<CircularLoader />}>
            <Main />
        </Suspense>
    )
}
export default ResetPassword